<script>
    import { fly } from 'svelte/transition';

    export let title = '';
    export let value = '';
    export let unit  = '';
    export let sub   = '';
    export let color = '';
    export let arrow = '';

    const fly_duration = 1000;
    
</script>

<div class="container">
    <div class="title">{title}</div>
    <div class="value">
         {#if value == ''}
           <svg width="48" height="14" viewBox="0 0 55 2" stroke="currentcolor" fill="currentcolor">
                <rect x="0" y="0" width="15" height="2">
                    <animate attributeName="opacity" dur="2s" repeatCount="indefinite" values="0.1;0.1;0.8;0.1" keyTimes="0;0.8;0.9;1" />
                </rect>
                <rect x="20" y="0" width="15" height="2">
                    <animate attributeName="opacity" dur="2s" repeatCount="indefinite" values="0.1;0.1;0.8;0.1" keyTimes="0;0.8;0.9;1" begin="0.1s"/>
                </rect>
                <rect x="40" y="0" width="15" height="2">
                    <animate attributeName="opacity" dur="2s" repeatCount="indefinite" values="0.1;0.1;0.8;0.1" keyTimes="0;0.8;0.9;1" begin="0.2s"/>
                </rect>
            </svg>
        {:else} 
            <div transition:fly="{{ y: -10, duration: fly_duration }}">
                {value}<span class="unit">{unit}</span>
            </div>
        {/if}
    </div>
    <div class="sub {color}">
        {#if arrow == "up"}
        <div transition:fly="{{ y: -10, duration: fly_duration }}">
            <svg width="9" height="9" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 0L8.83013 7.5H0.169873L4.5 0Z" fill="currentcolor"/>
            </svg>
        </div>
        {/if}

        {#if arrow == "down"}
        <div transition:fly="{{ y: -10, duration: fly_duration }}">
            <svg width="9" height="9" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 8L0.169872 0.5L8.83013 0.5L4.5 8Z" fill="currentcolor"/>
            </svg>
        </div>
        {/if}

        {#if arrow == "even"}
        <div transition:fly="{{ y: -10, duration: fly_duration }}">
            <svg width="9" height="8" viewBox="0 0 9 7" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.0791 0.386719V2.39062H0.195312V0.386719H8.0791ZM8.0791 4.18359V6.1875H0.195312V4.18359H8.0791Z"/>
            </svg>
        </div>
        {/if}

        {#if sub == '' && arrow != 'even'}
        <svg width="24" height="12" viewBox="0 0 55 3" stroke="currentcolor" fill="currentcolor">
            <rect x="0" y="0" width="15" height="3">
                <animate attributeName="opacity" dur="2s" repeatCount="indefinite" values="0.3;0.3;1;0.3" keyTimes="0;0.8;0.9;1" />
            </rect>
            <rect x="20" y="0" width="15" height="3">
                <animate attributeName="opacity" dur="2s" repeatCount="indefinite" values="0.3;0.3;1;0.3" keyTimes="0;0.8;0.9;1" begin="0.1s"/>
            </rect>
            <rect x="40" y="0" width="15" height="3">
                <animate attributeName="opacity" dur="2s" repeatCount="indefinite" values="0.3;0.3;1;0.3" keyTimes="0;0.8;0.9;1" begin="0.2s"/>
            </rect>
        </svg>
        {:else}
            {#key sub}
            <div in:fly="{{ y: -10, duration: fly_duration }}">
                {@html sub}
            </div>
            {/key}
        {/if}

    </div>
</div>

<style>

    .container {

        flex-grow: 1;
        flex-basis: 15%;

        background-color: var(--clr-background-100);
        transition: background-color 0.3s;

        border-radius: 0.5em;

        border-top: 1px solid rgba(var(--clr-foreground-csv), 0.05);
        box-shadow: 0 1px 2px 0px rgba(0,0,0, 0.25);
        
        padding-inline: 1em;
        padding-top: 0.25em;
        padding-bottom: 0.25em;

        min-height: 5em;
    }

    .title {
        font-size: 0.8em;
        color: var(--clr-foreground-100);
        font-weight: 300;
        margin-bottom: -0.1em;
    }

    .value {
        font-size: 1.4em;
        font-weight: 500;
        margin-bottom: -0.2em;
    }

    .unit {
        margin-left: 0.25em;
        font-size: 0.7em;
    }

    .sub {
        font-size: 0.8em;
        font-weight: 700;
        display: flex;
        gap: 0.25em;
        justify-content: center;
    }

    .green {
        color: #62C331;
    }

    .red {
        color: #e26a55;     /* D8784F */
    }

    .gray {
        color: rgb(187, 187, 187);    /* TODO: color from global css light/dark green*/
    }


/* 
    7-ITEMS resizing

@media screen and (max-width: 1160px)
{
	.container { flex: 1 0 21%; max-width: 25%; }
}

@media screen and (max-width: 800px)
{
	.container { flex: 1 0 25%; max-width: 33%; }
}

@media screen and (max-width: 650px)
{
	.container { flex: 1 0 33%; max-width: 50%; }
}
*/

@media screen and (max-width: 1160px)
{
    .container {
        flex-basis: auto;
    }
}

@media screen and (max-width: 1000px)
{
	.container {
        flex: 1 0 25%;
        max-width: 33%;
    }
}

@media screen and (max-width: 650px)
{
	.container {
        flex: 1 0 33%;
        max-width: 50%;
    }
}

</style>

